import logger from '../utils/rbata.logger';
import urlService from '../services/rbata.urlService';
import paymentPage from './rbata.payment-page';

const adyenService = {
    dropinContainer: undefined,
    dropinComponent: null,
    paypalComponent: null,
    dropInData:      undefined,
    paymentSelected: false,
    noPayment:       false,
    checkout:        null,
    paypal:          false,
    bcmcMobile:      false,

    handlePaypal: function (component) {
        if (component.props.type === 'paypal') {
            if (adyenService.paypalComponent == null) {
                adyenService.paypalComponent = adyenService.checkout.create('paypal', {showPayButton: true});
            }

            adyenService.paypalComponent.mount("#paypal-container");
            adyenService.paypal     = true;
            adyenService.bcmcMobile = false;
            $('#submitPayment').hide();
            $('#paypal-container').show();
        } else if (component.props.type === 'bcmc_mobile') {
            adyenService.bcmcMobile = true;
            adyenService.paypal     = false;
        } else {
            if (adyenService.paypalComponent != null) {
                adyenService.checkout.remove(adyenService.paypalComponent);
                adyenService.paypalComponent = null;
            }
            $('#paypal-container').html("").hide();
            $('#submitPayment').show();
            adyenService.paypal     = false;
            adyenService.bcmcMobile = false;
        }
    },

    onSelect(component) {
        logger.log('adyen onSelect', component)
        adyenService.paymentSelected = true;
        paymentPage.noPaymentError()
        adyenService.handlePaypal(component);
    },

    onError(error) {
        if (error.name === 'CANCEL') {
            logger.log('User cancelled payment');
        } else {
            logger.log("Error: " + error.name);
            logger.log("Message: " + error.message);
        }
        $('#submitPayment').removeAttr("disabled");
    },

    cacheSelectors() {
        this.dropinContainer = $('#dropin-container');
        this.dropInData      = $('#js-payment-data').data('dropin-data');
    },

    bindEvents() {
        if (this.dropinContainer.data('no-payment')) {
            this.dropinContainer
                .click(function (e) {
                    e.preventDefault();
                })
                .keypress(function (e) {
                    e.preventDefault();
                });
        }
    },

    onSubmit: (state, dropin) => {
        console.log("OnSubmit");
        adyenService.placeOrder(state);
    },

    placeOrder: (state) => {
        const stateData = state !== undefined ? state.data : {};
        $.ajax({
            url:         `${urlService.getBaseUrl()}checkout/multi/summary/placeOrder`,
            method:      'POST',
            contentType: 'application/json',
            data:        JSON.stringify({
                state: stateData, express: false
            })
        }).done((response) => {
            if (response.error !== true) {
                if (stateData.paymentMethod == undefined) {
                    adyenService.trackSelectedPaymentMode("zeroval");
                } else {
                    adyenService.trackSelectedPaymentMode(stateData.paymentMethod.type);
                }
                if (response.paymentsAction) {
                    adyenService.handleAction(response.paymentsAction);
                } else {
                    window.location.href = response.redirectUrl;
                }
            } else if (response.noDeliveryAddress === true) {
                $('#placeOrderNoDeliveryAddress').removeClass('d-none');
            } else if (response.inconsistentAddresses === true) {
                $('#placeOrderInconsistentAddresses').removeClass('d-none');
            } else if (response.cartNotCalculated === true) {
                $('#placeOrderCartNotCalculated').removeClass('d-none');
            } else {
                window.location.href = response.redirectUrl;
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in for placing order`)
        });
    },

    onAdditionalDetails: (state, dropin) => {
        logger.log('onAdditionalDetails');
        logger.log(state);
        logger.log(dropin);
        $.ajax({
            url: `${urlService.getBaseUrl()}checkout/payment/return/paypal/`, method: 'POST', contentType: 'application/json', data: JSON.stringify({
                state: state.data
            })
        }).done((response) => {
            if (response.redirectUrl) {
                window.location.href = `${urlService.getBaseUrl()}${response.redirectUrl}`;
            } else {
                window.location.reload;
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in after paypal return`)
        })
    },

    buildConfiguration() {
        return {
            paymentMethodsResponse:      adyenService.dropInData.paymentMethodsResponse,
            clientKey:                   adyenService.dropInData.clientKey,
            locale:                      adyenService.dropInData.locale,
            environment:                 adyenService.dropInData.environment,
            onError:                     adyenService.onError,
            onSubmit:                    adyenService.onSubmit,
            onAdditionalDetails:         adyenService.onAdditionalDetails,
            showPayButton:               false,
            analytics:                   {
                enabled: adyenService.dropInData.analytics
            },
            paymentMethodsConfiguration: {
                card:        {
                    enableStoreDetails: adyenService.dropInData.storeCards,
                    hasHolderName:      true,
                    holderNameRequired: true,
                    styles:             {
                        base:           {
                            fontFamily: 'NeueHaasUnica, sans-serif', fontSize: '12px',
                        }, placeholder: {
                            opacity:       0.2,
                            fontFamily:    'NeueHaasUnica, sans-serif',
                            fontSize:      '12px',
                            fontWeight:    'bold',
                            fontStyle:     'normal',
                            lineHeight:    '1.67',
                            letterSpacing: 'normal',
                            color:         '#1d1d1'
                        }
                    }
                }, paypal:   {
                    amount:      {
                        currency: adyenService.dropInData.currency, value: adyenService.dropInData.amount
                    },
                    locale:      adyenService.dropInData.locale,
                    intent:      adyenService.dropInData.intent,
                    environment: adyenService.dropInData.environment,
                    countryCode: adyenService.dropInData.countryCode
                }, applepay: {
                    amount:      {
                        currency: adyenService.dropInData.currency, value: adyenService.dropInData.amount
                    },
                    countryCode: adyenService.dropInData.countryCode
                }
            }
        }
    },

    async createAdyenInstance() {
        const configuration = this.buildConfiguration();

        // Create an instance of AdyenCheckout using the configuration object.
        adyenService.checkout = await AdyenCheckout(configuration);

        logger.log('configuration', configuration);
        logger.log('adyen component', adyenService.checkout);

        // Create an instance of Drop-in and mount it to the container you created.
        adyenService.dropinComponent = adyenService.checkout.create('dropin', {
            openFirstPaymentMethod: false, onSelect: adyenService.onSelect
        }).mount('#dropin-container');
    },

    initDropIn() {

        // In case zero value order (GC, Voucher...)
        adyenService.noPayment = this.dropinContainer.data('no-payment');
        adyenService.createAdyenInstance();
    },
    submitPayment() {
        if (adyenService.bcmcMobile) {
            $('html, body').animate({
                scrollTop: 150
            }, 350);
        }
        adyenService.dropinComponent.submit()
    },
    handleAction(action) {
        if (adyenService.paypal) {
            adyenService.paypalComponent.handleAction(action);
        } else {
            adyenService.dropinComponent.handleAction(action);
        }
    },
    trackSelectedPaymentMode(paymentMode) {
        paymentMode = paymentMode === 'scheme' ? 'creditcard' : paymentMode;
        if (paymentMode) {
            alphatauri.tracking.payment.ua.ecommerce.checkout.actionField.option = alphatauri.util.capitalizeFirstLetter(paymentMode);
            alphatauri.tracking.payment.ga4.ecommerce.payment_type               = alphatauri.util.capitalizeFirstLetter(paymentMode);
            dataLayer.push(alphatauri.tracking.payment.ua);
            dataLayer.push(alphatauri.tracking.payment.ga4);
        }
    }

}
$(() => {
    if ($('#payment-page').length) {
        adyenService.cacheSelectors();
        adyenService.bindEvents();
        adyenService.initDropIn();
    }
});

export default adyenService
